module.exports = __webpack_public_path__ + "img/ic_eye_open.eb091637.svg";